import * as React from 'react';;
import { Store } from '../../models/store';
import { useStoreTypes, StoreType } from '../../contexts/StoreTypesContext';
import { Package, Edit, Trash2 } from 'lucide-react';

interface StoreListProps {
    stores?: Store[] | null;
    onEdit?: (store: Store, storeTypes: StoreType[]) => void;
    onDelete?: (storeId: number) => void;
    onProducts?: (storeId: number) => void;
}

const StoreList: React.FC<StoreListProps> = ({ 
    stores = [], 
    onEdit = () => {}, 
    onDelete = () => {}, 
    onProducts = () => {} 
}) => {
    const { storeTypes } = useStoreTypes();
    
    if (!stores || stores.length === 0) {
        return (
            <div className="p-4 bg-white/50 rounded-lg text-center">
                <p className="text-gray-500">No stores available</p>
            </div>
        );
    }

    return (
        <div className="overflow-hidden bg-white/70 rounded-lg">
            <table className="w-full">
                <thead>
                    <tr className="border-b border-gray-200">
                        <th className="p-2 text-left text-gray-700 font-medium">Name</th>
                        <th className="p-2 text-left text-gray-700 font-medium">Location</th>
                        <th className="p-2 text-left text-gray-700 font-medium">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {stores.map(store => (
                        <tr key={store.storeId} className="border-b border-gray-100 hover:bg-indigo-50/50 transition-colors">
                            <td className="p-3 text-gray-800">{store.storeName}</td>
                            <td className="p-3 text-gray-800">{store.pickupLocation || 'N/A'}</td>
                            <td className="p-3 space-x-2">
                                <button 
                                    onClick={() => onProducts(store.storeId!)} 
                                    className="px-3 py-1 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors inline-flex items-center gap-1"
                                >
                                    <Package className="w-4 h-4" />
                                    Products
                                </button>
                                <button 
                                    onClick={() => onEdit(store, storeTypes)} 
                                    className="px-3 py-1 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors inline-flex items-center gap-1"
                                >
                                    <Edit className="w-4 h-4" />
                                    Edit
                                </button>
                                <button 
                                    onClick={() => onDelete(store.storeId!)} 
                                    className="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors inline-flex items-center gap-1"
                                >
                                    <Trash2 className="w-4 h-4" />
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default StoreList;
